export const EnvConfig = {
    BASE_API_URL:
        import.meta.env.VITE_BASE_API_URL ?? 'http://localhost:3000/v1',
    APP_NAME: import.meta.env.VITE_APP_NAME ?? 'Pharmacy POS',
    APP_ENV: import.meta.env.VITE_APP_ENV ?? 'development',
    VERSION: '1.8.11',
} as const;
